export default "data:image/webp;base64,UklGRk4AAABXRUJQVlA4IEIAAADQAQCdASoQAAsAAsBMJagCdAEPCCpq4AD+3oFjroPO0ze5iNaIw+zvemoK+NvVACOP3TvypOriqrkRJbg4ruVsAAA=";